import { render, staticRenderFns } from "./attribute-create-update-dialog.vue?vue&type=template&id=221f6630&scoped=true"
import script from "./attribute-create-update-dialog.vue?vue&type=script&lang=js"
export * from "./attribute-create-update-dialog.vue?vue&type=script&lang=js"
import style0 from "./attribute-create-update-dialog.vue?vue&type=style&index=0&id=221f6630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221f6630",
  null
  
)

export default component.exports